module.exports = __webpack_public_path__ + "static/img/duijiang2.834e3d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/duijiang2.png
// module id = 8g/U
// module chunks = 24